import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { WsUiModule } from '@web/util/ws-ui/ws-ui.module';
import { AdditionalQuestionsPopupComponent } from './additional-questions-popup.component';

@NgModule({
  declarations: [AdditionalQuestionsPopupComponent],
  entryComponents: [AdditionalQuestionsPopupComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    TranslateModule,
    WsUiModule,
  ],
})
export class AdditionalQuestionsPopupModule {}
